<template>
  <div class="list-view"> <!-- product-checkout mt-0 -->
    <div class="checkout-items">
      <b-card
        class="ecommerce-card"
        no-body
      >
        <!-- Product Options/Actions -->
        <div class="item-options text-center">
          <div class="item-wrapper">
            <div class="item-cost">
              <h4 class="item-price">
                Coordenadas de Parcela
              </h4>
              <br>
              <!-- <p
                class="card-text shipping"
              >
                <b-badge
                  pill
                  variant="light-success"
                >
                  Se mostrará la lista de puntos
                </b-badge>
              </p> -->
              <div
                v-for="item in items"
                :key="item.idParcelaCoordenada"
                class="employee-task d-flex justify-content-between align-items-center"
              >
                <b-media no-body>
                  <!-- <b-media-aside class="mr-75">
                    <b-avatar
                      rounded
                      size="42"
                      :src="item.avatar"
                    />
                  </b-media-aside> -->
                  <b-media-body class="my-auto">
                    <h6 class="mb-2">
                      - Lat: {{ item.latitud }} Lng: {{ item.latitud }}
                    </h6>
                    <!-- <small>Longitud: {{ item.latitud }}</small> -->
                  </b-media-body>
                </b-media>
                <!-- <div class="d-flex align-items-center">
                  <small class="text-muted mr-75">20.0</small>
                </div> -->
              </div>
            </div>
          </div>
          <b-button
            variant="light"
            class="mt-1 remove-wishlist"
            @click="$router.push({ name: 'app-cultivo-parcela'})"
          >
            <feather-icon
              icon="ArrowLeftIcon"
              class="mr-50"
            />
            <span>Atras</span>
          </b-button>
          <!-- <b-button
            variant="primary"
            class="btn-cart move-cart"
            for="file"
          >
            <feather-icon
              icon="FileTextIcon"
              class="mr-50"
            />
            <span class="text-nowrap">Mostrar Parcela de Excel</span>
          </b-button> -->
          <br>
          <label
            for="file"
            class="btn btn-outline-success btn-block"
          >
            <feather-icon
              icon="FileTextIcon"
              class="mr-50"
            />
            Importar y ver Parcela
          </label>
          <input
            v-show="false"
            id="file"
            type="file"
            @change="onChange"
          >
        </div>
        <!-- Product Details: Card Body -->
        <b-card-body>
          <div class="row">
            <div class="col-sm-12">
              <h3 style="text-align: center;">
                VISOR DE MAPA DE PARCELAS
              </h3>
              <google-map
                v-if="mapEnabled"
                :latitude="latitude"
                :longitude="longitude"
                :title="title"
                :data-parcela.sync="dataParcela"
              />
            </div>
          </div>
        </b-card-body>
      </b-card>
    </div>
  </div>
</template>

<script>
import router from '@/router'
import {
  BCard, BCardBody, BButton, BMedia, BMediaBody,
} from 'bootstrap-vue'
import { _ } from 'vue-underscore'
import store from '@/store'
import XLSX from 'xlsx'
import GoogleMap from './GoogleMap.vue'

export default {
  components: {
    BCard,
    BCardBody,
    BButton,
    // BBadge,
    BMedia,
    BMediaBody,
    /** COMPONENTES */
    GoogleMap,
  },
  data: () => ({
    items: [],
    paths: [],
    latitude: -6.0220945,
    longitude: -76.9884157,
    title: 'Título de Marcador',
    dataParcela: {},
    mapEnabled: false,
  }),
  mounted() {
    this.loadParcelaCoordena()
  },
  methods: {
    async loadParcelaCoordena() {
      await store
        .dispatch('gsencuesta/PARCELA_FIND', {
          idParcela: router.currentRoute.params.id,
        })
        .then(response => {
          if (response !== undefined) {
            // this.paths = response
            this.items = []
            if (response.parcelaCoordenada.length > 0) {
              response.parcelaCoordenada.forEach(item => {
                this.items.push({
                  latitud: parseFloat(item.latitud),
                  longitud: parseFloat(item.longitud),
                })
              })
            }
            this.dataParcela = response
            this.mapEnabled = true
          }
        })
        .catch(error => {
          this.$bvToast.toast(error, {
            title: 'He ocurrido un error',
            variant: 'danger',
            solid: true,
          })
        })
    },
    async onChange(event) {
      this.mapEnabled = false
      const file = event.target.files ? event.target.files[0] : null // files[0]
      if (file) {
        const fileReader = new FileReader()
        fileReader.onload = e => {
          let binary = ''
          const bytes = new Uint8Array(e.target.result)
          const length = bytes.byteLength
          for (let i = 0; i < length; i += 1) {
            binary += String.fromCharCode(bytes[i])
          }
          const workbook = XLSX.read(binary, { type: 'binary', cellDates: true, dateNF: 'dd/mm/yyyy;@' })
          const sheetNameList = workbook.SheetNames
          this.paths = []
          this.items = []
          sheetNameList.forEach(y => {
            const roa = XLSX.utils.sheet_to_json(workbook.Sheets[y])
            this.paths = []
            this.items = []
            if (roa.length > 0) {
              roa.forEach(dat => {
                const lat = _.isUndefined(dat.LATITUD) ? 0 : parseFloat(dat.LATITUD)
                const lng = _.isUndefined(dat.LONGITUD) ? 0 : parseFloat(dat.LONGITUD)
                this.paths.push({
                  latitud: lat,
                  longitud: lng,
                })
                this.items.push({
                  latitud: lat,
                  longitud: lng,
                })
              })
              this.dataParcela = {
                descripcion: 'Parcela Importada',
                parcelaCoordenada: this.paths,
              }
              this.mapEnabled = true
            }
          })
        }
        fileReader.readAsArrayBuffer(file)
      }
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-wizard.scss';
@import '~@core/scss/base/pages/app-ecommerce.scss';
@import '~vue-form-wizard/dist/vue-form-wizard.min.css';
</style>

<style lang="scss" scoped>
.checkout-form-wizard ::v-deep {
  .wizard-tab-content {
    box-shadow: none !important;
    background: transparent !important;
    padding: 0;
  }
}
.ecommerce-application .list-view .ecommerce-card {
    overflow: hidden;
    display: grid;
    grid-template-columns: 0.83fr 2fr !important;
}
</style>
